import type { MeProfileAssignmentRowDTO } from "@/modules/users/domain/employee-profile.types";
import { formatDateLocal } from "@/shared/lib/date-time";
import {
  Badge,
  ScrollArea,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@devhop/ui";

type ProfileAssignmentHistoryTableProps = {
  rows: MeProfileAssignmentRowDTO[];
};

export function ProfileAssignmentHistoryTable({
  rows,
}: ProfileAssignmentHistoryTableProps) {
  if (rows.length === 0) {
    return (
      <div className="rounded-xl border border-dashed bg-muted/20 py-10 text-center">
        <p className="text-muted-foreground text-sm">ບໍ່ມີປະຫວັດຕຳແໜ່ງ</p>
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-xl border bg-card shadow-sm">
      <ScrollArea className="max-h-[min(55vh,440px)]">
        <Table>
          <TableHeader>
            <TableRow className="border-b bg-muted/40 hover:bg-muted/40">
              <TableHead className="font-semibold">ຕຳແໜ່ງ</TableHead>
              <TableHead className="font-semibold">ພະແນກ</TableHead>
              <TableHead className="whitespace-nowrap font-semibold">
                ເລີ່ມ
              </TableHead>
              <TableHead className="whitespace-nowrap font-semibold">
                ສິ້ນສຸດ
              </TableHead>
              <TableHead className="w-[100px] text-center font-semibold">
                ຫຼັກ
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((r) => (
              <TableRow key={r.id} className="transition-colors hover:bg-muted/30">
                <TableCell className="align-middle font-medium">
                  {r.positionTitle ?? "—"}
                </TableCell>
                <TableCell className="align-middle text-muted-foreground">
                  {r.departmentName ?? "—"}
                </TableCell>
                <TableCell className="whitespace-nowrap align-middle text-sm">
                  {formatDateLocal(r.startDate)}
                </TableCell>
                <TableCell className="whitespace-nowrap align-middle text-sm">
                  {r.endDate ? formatDateLocal(r.endDate) : "—"}
                </TableCell>
                <TableCell className="text-center align-middle">
                  {r.isPrimary ? (
                    <Badge variant="secondary" className="font-normal">
                      ຫຼັກ
                    </Badge>
                  ) : (
                    <span className="text-muted-foreground">—</span>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </ScrollArea>
    </div>
  );
}
